import { TradingViewTimeframesEnum } from '@modules/trading-view-module/enums/trading-view-timeframes.enum'

export const TimeframesWithPrePostLines: TradingViewTimeframesEnum[] = [
	TradingViewTimeframesEnum.oneDay,
	TradingViewTimeframesEnum.oneWeek,
	TradingViewTimeframesEnum.oneMonth,
	TradingViewTimeframesEnum.oneYear,
]
